import script from "./publishEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./publishEdit.vue?vue&type=script&setup=true&lang=js"

import "./publishEdit.vue?vue&type=style&index=0&id=9c97c81c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c97c81c"]])

export default __exports__